import { render, staticRenderFns } from "./SeminarParticipantsTable.vue?vue&type=template&id=13a9d5e5&"
import script from "./SeminarParticipantsTable.vue?vue&type=script&lang=js&"
export * from "./SeminarParticipantsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports